import { Link } from '@components/gassan-ui'
import { PreOwnedJewelsServiceContent } from '@lib/kontent/navigation-helpers/get-pre-owned-service-content'
import NextLink from 'next/link'
import { FC } from 'react'
import { HeaderImageColumn } from '../../image-column'
import { HeaderLinkColumn } from '../../link-column'

type HeaderMobileNavService = PreOwnedJewelsServiceContent

export const Service: FC<HeaderMobileNavService> = ({ linkList, imageLinkColumn }) => {
  return (
    <>
      <HeaderLinkColumn
        title={linkList.title}
        readMoreLink={
          linkList.viewMore && (
            <NextLink href={linkList.viewMore.url} passHref legacyBehavior>
              <Link variant="blue">{linkList.viewMore.label}</Link>
            </NextLink>
          )
        }
        links={linkList.links}
        linkSpace="regular"
      />
      <HeaderImageColumn {...imageLinkColumn} />
    </>
  )
}
